import { Send } from "lucide-react";
import React from "react";

export default function SavedModal({ open, onClose, onSend }) {
    if (!open) return null;

    const isMobile = window.innerWidth < 768;

    const overlayStyle = {
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.6)",
        display: "flex",
        alignItems: isMobile ? "flex-start" : "center",
        justifyContent: "center",
        paddingTop: isMobile ? 40 : 0,
        zIndex: 9999,
    };

    const modalStyle = {
        width: isMobile ? "90%" : 380,      // narrower on desktop
        maxWidth: "95%",
        background: "linear-gradient(180deg, #0f1418 0%, #0b0f13 100%)",
        borderRadius: isMobile ? 16 : 22,
        padding: isMobile ? "20px 16px 24px" : "24px 20px 28px",
        position: "relative",
        boxShadow: "0 25px 60px rgba(0,0,0,0.6)",
        color: "#ffffff",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    };

    const closeButtonStyle = {
        position: "absolute",
        top: isMobile ? 12 : 16,
        right: isMobile ? 12 : 16,
        width: isMobile ? 36 : 32,
        height: isMobile ? 36 : 32,
        borderRadius: "50%",
        border: "2px solid #ffffff",
        background: "transparent",
        color: "#ffffff",
        fontSize: 18,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };

    const iconWrapperStyle = {
        width: isMobile ? 48 : 54,
        height: isMobile ? 48 : 54,
        borderRadius: "50%",
        border: "4px solid #f5a623",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: isMobile ? "10px auto 16px" : "12px auto 22px",
    };

    const titleStyle = {
        fontSize: isMobile ? 24 : 28,
        fontWeight: 700,
        margin: isMobile ? "0 0 8px" : "0 0 12px",
    };

    const subtitleStyle = {
        fontSize: isMobile ? 14 : 15,
        lineHeight: 1.6,
        color: "#9aa3ad",
        marginBottom: isMobile ? 20 : 28,
    };

    const buttonStyle = {
        width: "100%",
        height: isMobile ? 56 : 64,
        borderRadius: 16,
        border: "none",
        background: "linear-gradient(90deg, #f5a623 0%, #ff7a18 50%, #ff4d4f 100%)",
        color: "#ffffff",
        fontSize: isMobile ? 18 : 22,
        fontWeight: 600,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
    };

    return (
        <div style={overlayStyle}>
            <div style={modalStyle}>
                <button style={closeButtonStyle} onClick={onClose}>
                    ✕
                </button>

                <div style={iconWrapperStyle}>
                    <svg width={isMobile ? 28 : 32} height={isMobile ? 20 : 22} viewBox="0 0 42 32" fill="none">
                        <path
                            d="M4 16L16 28L38 4"
                            stroke="#f5a623"
                            strokeWidth="5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>

                <h2 style={titleStyle}>Saved</h2>

                <p style={subtitleStyle}>
                    Saved the image. You can now send it<br />
                    to Live Devices
                </p>

                <button onClick={onSend} style={buttonStyle}>
                    <Send size={16} color="#000" />
                    Send to Live Devices
                </button>
            </div>
        </div>
    );
}
